import React from 'react'
import { Container, Button, Panel } from '@sencha/ext-modern'

export default props => {
  const { location, home, history } = props
  let message = ''
  if (location && location.state)
    message = location.state.message
  return (
    <Container fullScreen layout={{ type: 'vbox', align: 'center' }} padding={10}>
      <Panel ui="instructions" margin="30 0 10 0">
        <h2>{message || '您访问的页面不存在'}</h2>
      </Panel>
      {history &&
        <Button ui='action' text='返回主页' handler={() => {
          history.push(home || '/')
        }}
        />
      }
    </Container>
  )
}